<template>
  <div class="hideTotal">
    <!-- 搜索 -->
    <table-search
      label-width="65px"
      @search="fetchList(1)"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <!-- <el-form-item label="组织">
          <el-select
            v-model="query.marketId"
            placeholder="请选择组织"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.organization"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="购销计划">
          <el-input
            v-model="query.goodsCode"
            placeholder="请输入购销计划"
          />
        </el-form-item>
        <el-form-item label="交货状态">
          <el-select
            v-model="query.statusEx"
            placeholder="请选择交货状态"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.statusEx"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="交货方式">
          <el-select
            v-model="query.deliveryMode"
            placeholder="请选择交货状态"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.deliveryMode"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="客户号">
          <el-input
            v-model="query.tradeUserAccount"
            placeholder="请输入客户号"
          />
        </el-form-item>
        <el-form-item
          label="交货日期"
          class="datePicker"
        >
          <el-date-picker
            v-model="query.date"
            type="date"
            placeholder="选择日期"
          />
        </el-form-item>
      </template>
    </table-search>
    <!-- 导出 -->
    <inquery-result isTips @export="toDownload" />
    <!-- 表格 -->
    <el-table :data="tableData">
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <!-- <af-table-column
        fixed
        prop="marketName"
        label="组织"
      /> -->
      <af-table-column
        fixed
        prop="tradingDate"
        label="交货日期"
      />
      <af-table-column
        fixed
        prop="deliveryNo"
        label="交货编号"
      />
      <af-table-column
        prop="holdDetailNo"
        label="订货编号"
      />
      <af-table-column
        prop="userAccount"
        label="客户"
      />
      <af-table-column
        prop="tradeUserAccount"
        label="客户号"
      />
      <af-table-column
        prop="userName"
        label="客户名称"
      />
      <af-table-column
        prop="goodsCode"
        label="购销计划"
      />
      <af-table-column
        prop="deliveryAmount"
        label="交货量"
      />
      <af-table-column
        prop="holdPriceExp"
        label="交货价"
      />
      <af-table-column
        prop="calcDepositAmount"
        label="保证金量"
      />
      <af-table-column
        prop="freezeDeliveryDepositExp"
        label="交货保证金"
      />
      <af-table-column
        prop="calcProfitAmount"
        label="交货盈亏量"
      />
      <af-table-column
        prop="deliveryProfitOrLostExp"
        label="交货盈亏"
      />
      <af-table-column
        prop="deliveryMode"
        label="交货方式"
      />
      <af-table-column
        prop="operatorNo"
        label="移仓办理人"
      />
      <af-table-column
        prop="endDate"
        label="办结日期"
      />
      <af-table-column
        prop="statusEx"
        label="交货状态"
      />
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, prev, pager, next"
      :current-page.sync="currentPage"
      :total="total"
      background
      @current-change="changePage"
    />
  </div>
</template>
<script>
import api from '@/api'
import dayJs from 'dayjs'

function Query () {
  this.marketId = '000' // 组织编号
  this.goodsCode = '' // 购销计划
  this.statusEx = '' // 交货状态
  this.deliveryMode = '' // 交货方式
  this.tradeUserAccount = '' // 客户号
  this.date = '' // 交货日期
}
export default {
  name: 'HistoricalSettlementDetailInquiry',
  data () {
    return {
      query: new Query(),

      currentPage: 1,
      total: 0,
      pageSize: 10,
      marketId: '',
      tableData: [], // 表格数据
    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (currentPage, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentPage = currentPage || this.currentPage || 1
      let param = {
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      param.tradingDate = param.date ? dayJs(this.query.date).format('YYYYMMDD') : '' // 默认时间，不附带时间将会返回所有数据，而且连分页都没做
      let res = await api.spotPurchaseSaleInquiry.HistoricalSettlementDetailInquiry(param)
      this.total = res.data.totalItem
      this.tableData = res.data.items
      this.marketId = this.query.marketId
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    // 导出
    toDownload () {
      let param = {
        marketId: this.marketId,
        execlType: '24',
        excelHead: [
          // {
          //   fieldLabel: '组织',
          //   excelColumn: 'marketName'
          // },
          {
            fieldLabel: '交货日期',
            excelColumn: 'tradingDate'
          },
          {
            fieldLabel: '交货编号',
            excelColumn: 'deliveryNo'
          },
          {
            fieldLabel: '订货编号',
            excelColumn: 'holdDetailNo'
          },
          {
            fieldLabel: '客户',
            excelColumn: 'userAccount'
          },
          {
            fieldLabel: '客户号',
            excelColumn: 'tradeUserAccount'
          },
          {
            fieldLabel: '客户名称',
            excelColumn: 'userName'
          },
          {
            fieldLabel: '购销计划',
            excelColumn: 'goodsCode'
          },
          {
            fieldLabel: '交货量',
            excelColumn: 'deliveryAmount'
          },
          {
            fieldLabel: '交货价',
            excelColumn: 'holdPriceExp'
          },
          {
            fieldLabel: '保证金量',
            excelColumn: 'calcDepositAmount'
          },
          {
            fieldLabel: '交货保证金',
            excelColumn: 'freezeDeliveryDepositExp'
          },
          {
            fieldLabel: '交货盈亏量',
            excelColumn: 'calcProfitAmount'
          },
          {
            fieldLabel: '交货盈亏',
            excelColumn: 'deliveryProfitOrLostExp'
          },
          {
            fieldLabel: '交货方式',
            excelColumn: 'deliveryMode'
          },
          {
            fieldLabel: '移仓办理人',
            excelColumn: 'operatorNo'
          },
          {
            fieldLabel: '办结日期',
            excelColumn: 'endDate'
          },
          {
            fieldLabel: '交货状态',
            excelColumn: 'statusEx'
          }
        ]
      }
      this.$utils.getExcelFile(this, api.download, param)
    },
    // 换页
    changePage (page) {
      this.fetchList(page)
    },
  }
}

</script>
<style lang="scss" scoped>
  // 按钮对齐搜索框
  ::v-deep .table-page-search-submitButtons {
    margin-left: 100px
  }

</style>
